import React from "react"
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from "@mui/material"
import type { ValidationError } from "./ValidationSchema.tsx"

interface ErrorDialogProps {
  open: boolean
  onClose: () => void
  errors: ValidationError[]
  title: string
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({ open, onClose, errors, title }) => {
  // Group errors by step
  const step1Errors = errors.filter(
    (error) =>
      error.field.startsWith("date") ||
      error.field.startsWith("rating_") ||
      error.field.startsWith("staffMemberDesc") ||
      error.field.startsWith("textInput_"),
  )

  const step2Errors = errors.filter((error) => error.field.startsWith("question_"))

  const step3Errors = errors.filter(
    (error) =>
      error.field.startsWith("invoice_") ||
      error.field.startsWith("taskPhotos") ||
      error.field.startsWith("invoiceReceipt") ||
      error.field.startsWith("checkInFile") ||
      error.field.startsWith("checkOutFile"),
  )

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ bgcolor: "#f8f8f8", color: "#d32f2f" }}>{title}</DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        {step1Errors.length > 0 && (
          <Box mb={2}>
            <Typography variant="subtitle1" fontWeight="bold" color="primary">
              Step 1: Rate Your Experience
            </Typography>
            {step1Errors.map((error, index) => (
              <Typography key={index} color="error" variant="body2" sx={{ mt: 0.5 }}>
                • {error.message}
              </Typography>
            ))}
          </Box>
        )}

        {step2Errors.length > 0 && (
          <Box mb={2}>
            <Typography variant="subtitle1" fontWeight="bold" color="primary">
              Step 2: Questions
            </Typography>
            {step2Errors.map((error, index) => (
              <Typography key={index} color="error" variant="body2" sx={{ mt: 0.5 }}>
                • {error.message}
              </Typography>
            ))}
          </Box>
        )}

        {step3Errors.length > 0 && (
          <Box mb={2}>
            <Typography variant="subtitle1" fontWeight="bold" color="primary">
              Step 3: Other Details
            </Typography>
            {step3Errors.map((error, index) => (
              <Typography key={index} color="error" variant="body2" sx={{ mt: 0.5 }}>
                • {error.message}
              </Typography>
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ErrorDialog
